import { Injectable } from "@angular/core";
import { HubGroup } from "@appcore/models";
import { GroupUsers } from "@data/security";
import { API } from "@service/system/api.service";
import { HttpManager } from "@service/system/httpManager.service";
import { Observable } from "rxjs";

const API_URL = API.API_URL;

@Injectable()
export class SecurityGroupsUsersService {
  private _securityAPIBase = `${API_URL}/security`;

  constructor(private httpManager: HttpManager) { }

  // Gets a list of users for a single group
  getGroupUsers(groupID: number, affiliated: boolean): Observable<GroupUsers[]> {
    return this.httpManager.httpGet<GroupUsers[]>(`${this._securityAPIBase}/groupusers/${groupID}`, { affiliated: affiliated });
  }

  //Connect Groups to a User
  addGroupsToUser(userID: string, userGroups: string): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._securityAPIBase}/usergroupsjunction/${userID}/add`, userGroups);
  }

  //Connect Users to a Group
  addUsersToGroup(userIDs: string, groupID: string): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._securityAPIBase}/groupusersjunction/${groupID}/add`, userIDs);
  }

  //Gets a list of goups for a singleuser
  getUserGroups(id: string): Observable<HubGroup[]> {
    return this.httpManager.httpGet<HubGroup[]>(`${this._securityAPIBase}/usergroups/${id}`);
  }

  //delete releationship between a Security Group and a given User
  deleteGroupUser(groupID: number, userID: string): Observable<any> {
    return this.httpManager.httpPost<any>(`${this._securityAPIBase}/groupuser/${groupID}/delete`, userID);
  }
}
